import type { AppState } from 'state/model';

const getStrippingState = (state: AppState, quoteId: string) => state.fxOptions.strippings[quoteId];

export const isOptionStrippingOpen = (state: AppState, quoteId: string) =>
  getStrippingState(state, quoteId) !== undefined;

export const getOptionStrippingError = (state: AppState, quoteId: string) =>
  getStrippingState(state, quoteId)?.error;
